





























import { defineComponent, computed, useRouter } from "@nuxtjs/composition-api";
import { useSlickOptions } from "~/stores/extensionApi";
import LazyComponent from "v-lazy-component/vue2";
import SwiperCarousel from "~/components/SwiperCarousel.vue";
import SkeletonPlaceholder from "~/components/SkeletonPlaceholder.vue";
import CategoryProductFace from "~/modules/catalog/category/components/views/CategoryProductFace.vue";
import { useCategoryStore } from "~/modules/catalog/category/stores/category";
import { getUrlPathByCategory } from "~/modules/catalog/category/helpers";

export default defineComponent({
  name: "ThreeColumnBanners",
  components: {
    LazyComponent,
    SwiperCarousel,
    SkeletonPlaceholder,
    CategoryProductFace,
  },
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props) {
    const router = useRouter();
    const slickOptions = useSlickOptions();
    const categoryStore = useCategoryStore();
    const categoryTree = computed(() => categoryStore.categories);

    const slickBlockProductBannerOptions = computed(
      () => slickOptions.slickBlockProductBannerOptions
    );

    const goToCateById = async (row) => {
      const url_path = getUrlPathByCategory(row, categoryTree.value);
      if (url_path) {
        router.push(`/${url_path}`);
      }
    };

    return {
      slickBlockProductBannerOptions,
      goToCateById,
    };
  },
});
